var map = {
	"./404_images/404.png": "./src/assets/404_images/404.png",
	"./404_images/404_cloud.png": "./src/assets/404_images/404_cloud.png",
	"./dcopslogo.png": "./src/assets/dcopslogo.png",
	"./dcopslogo2.png": "./src/assets/dcopslogo2.png",
	"./dcopslogo3.png": "./src/assets/dcopslogo3.png",
	"./hd.png": "./src/assets/hd.png",
	"./ld.png": "./src/assets/ld.png",
	"./logo.png": "./src/assets/logo.png",
	"./quill/html.png": "./src/assets/quill/html.png",
	"./quill/txt.png": "./src/assets/quill/txt.png",
	"./quill/upload.png": "./src/assets/quill/upload.png",
	"./鸿云恒达LOGO-03.png": "./src/assets/鸿云恒达LOGO-03.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/.*$";